<div
  class="modal-container-custom"
  role="alertdialog"
  aria-modal="true"
  [attr.aria-label]="contentTitle"
>
  <div class="modal-header">
    <h2 class="modal-title text-left h5">{{ contentTitle }}</h2>
  </div>
  <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>

<ng-template #information>
  <div class="modal-content">
    <div class="modal-body py-0">
      <p
        class="alert-text"
        *ngFor="let message of messages"
      >
        {{ message }}
      </p>
    </div>
    <div class="modal-footer justify-content-start">
      <button
        type="button"
        class="btn btn-primary"
        aria-label="Ok button"
        (click)="closeModal()"
      >
        OK
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmation>
  <div class="modal-content">
    <div class="modal-body py-0">
      <p
        class="alert-text"
        *ngFor="let message of messages"
      >
        {{ message }}
      </p>
    </div>
    <div class="modal-footer justify-content-start">
      <button
        type="button"
        class="btn btn-primary"
        (click)="action('YES')"
      >
        Continue
      </button>
      <button
        type="button"
        class="btn btn-nr-secondary"
        aria-label="close Modal"
        (click)="closeModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>
